// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { add, evolve } from 'ramda';

// aliased
// import Link from 'components/Link';

// local
import styles from './Scroll.pcss';

export default class Scroll extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string),
    speed: PropTypes.number,
  }
  static defaultProps = {
    items: [],
    speed: 3000,
  }
  
  state = {
    n: 0,
  }
  
  componentWillMount() {
    const id = setInterval(() => {
      this.setState(evolve({ n: add(1) }));
    }, this.props.speed);
  
    this.unsub = _ => clearTimeout(id);
  }
  
  componentWillUnmount = () => this.unsub()
  
  render() {
    const { className, items } = this.props;
    const classNames = classnames(className, styles.scroll);
    
    const item = (this.state.n % items.length);
    
    const transform = `translate(0, -${ item * (1 / items.length) * 100 }%)`;
        
    return (
      <div className={ classNames }>
        <div style={{ transform }} className={ styles.inner }>
          {
            items.map((item, i) => (
              <p className={ styles.line } key={ i }>
                { item }
              </p>
            ))
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeView/Scroll/index.jsx